export const environment = {
  production: true,
  clientId: 'siapbos-webapp',
  clientSecret: '123456',
  uriApi: '/api',
  uriApiBop: '/api-bop',
  uriAuth: '/auth-server',
  uriReport: '/report-server',
  uriIntegration: '/integration-server',
  uriUploader: '/uploader',
  encryptionKey: 'z0YmP7K104Ql941z',
  uriUploaderFile: '/file-uploader',
};
